import { render, staticRenderFns } from "./PrintTax.vue?vue&type=template&id=e4423f10&scoped=true"
import script from "./PrintTax.vue?vue&type=script&lang=js"
export * from "./PrintTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4423f10",
  null
  
)

export default component.exports